










































import {Component, Prop, Vue} from 'vue-property-decorator';
import ChatbotAvatar from '@/components/images/ChatbotAvatar.vue';
import {Conversation, FormType, Output} from '@/types/asix';
import {AsixModule} from '@/store/modules/asix';
import {AppModule} from '@/store/modules/app';

@Component({
  components: {
    ChatbotAvatar,
  },
})
export default class TextBubble extends Vue {
  public sending: boolean = false;
  private textTypes = [
    FormType.Text,
    FormType.RichText,
    FormType.HeadText,
    FormType.ImgText,
  ]

  @Prop({required: true})
  private conversation!: Conversation;

  get formType() {
    return FormType
  }

  get texts(): Output[] {
    return this.conversation.outList.filter((o: Output) => this.textTypes.includes(o.expression_form))
  }

  get listItems(): Output[] {
    return this.conversation.outList.filter((o: Output) => o.expression_form === FormType.Button)
  }

  get isLast(): boolean {
    return AsixModule.latestBotConv ? AsixModule.latestBotConv.id === this.conversation.id : false
  }

  public async send(item: Output): Promise<void> {
    try {
      this.sending = true
      await AsixModule.listPost(item)
    } catch (e) {
      AppModule.setIsMaintenance(true)
    } finally {
      this.sending = false
    }
  }


  public onIntersect(entries: any, observer: any) {
    if (this.isLast) {
      AppModule.setIsShowMoreMsg(!entries[0].isIntersecting)
    }
  }
}
